import { isEmpty, map, join, startsWith, toLower, includes } from "lodash/fp";

import { FileCandidate } from "./types";

export const getFileSizeMB = (size: number): number => {
  return size / 1000 / 1000;
};

export const getFileSizeDisplay = (size: number | null): string => {
  if (!size) return "N/A";

  const KB = size / 1000;
  const MB = KB / 1000;
  const GB = MB / 1000;

  if (GB > 1) {
    return `${GB.toFixed(2)} GB`;
  } else if (MB > 1) {
    return `${MB.toFixed(2)} MB`;
  }
  return `${KB.toFixed(2)} KB`;
};

export const getInputAcceptAttr = (types?: string[]): string => {
  if (!types) return "";

  return join(
    ",",
    map(
      (type: string) => toLower(startsWith(".", type) ? type : `.${type}`),
      types
    )
  );
};

export const isValidType = (file: File, types?: string[]): boolean => {
  if (isEmpty(types)) return true;

  const ext = file.name.split(".").pop() ?? "unknown";
  return includes(ext, map(toLower, types));
};

export const validateFile = (
  file: File,
  {
    types = [],
    maxFileSizeMB = Infinity,
  }: { types?: string[]; maxFileSizeMB?: number } = {}
): FileCandidate => {
  if (!isValidType(file, types)) {
    return {
      isValid: false,
      message: `Only ${getInputAcceptAttr(types)} files are allowed`,
      invalidReason: "invalid_type",
      file,
    };
  }

  if (getFileSizeMB(file.size) > maxFileSizeMB) {
    return {
      isValid: false,
      message: `File size (${getFileSizeDisplay(
        file.size
      )}) should be less than ${maxFileSizeMB / 1000} GB`,
      invalidReason: "too_large",
      file,
    };
  }

  return { isValid: true, message: "", file };
};
